__turbopack_context__.v({
  "className": "helveticanowtext_a80dc170-module__THo1pq__className",
  "variable": "helveticanowtext_a80dc170-module__THo1pq__variable",
});
